import React, { Component } from 'react';
import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Body from './Body';
import { getResources } from '../../../modules/Resource';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    try {
      this.setState({
        isLoading: false,
      });
    } catch(e) {
      alert(e.message);
    }
  }

  render() {
    const { authState } = this.props;
    const { isLoading } = this.state;

    let pendingEmail = false;

    // if user logs out while on account page, userData is not defined...
    const userData = authState.userData || {};

    return isLoading ? (
      <LoadingSpinnerPage/>
    ) : (
      <Body
        userData={userData}
        pendingEmail={pendingEmail}
      />
    )
  }
}

Account.propTypes = {
  
};

Account.defaultProps = {
  
};


function mapStateToProps(state) {
  return {
    authState: state.authState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
  }, dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(Account);

